module.exports = __webpack_public_path__ + "media/3x/A-d46de992.png";